import { render, staticRenderFns } from "./IndustryComparison.vue?vue&type=template&id=571fa43e&scoped=true"
import script from "./IndustryComparison.vue?vue&type=script&lang=js"
export * from "./IndustryComparison.vue?vue&type=script&lang=js"
import style0 from "./IndustryComparison.vue?vue&type=style&index=0&id=571fa43e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571fa43e",
  null
  
)

export default component.exports